interface TimeRangeSelectorProps {
  selected: number;
  onChange: (hours: number) => void;
  disabled: boolean;
}

export function TimeRangeSelector({ selected, onChange, disabled }: TimeRangeSelectorProps) {
  const options = [
    { hours: 24, label: '1 Day', description: '24 hours' },
    { hours: 48, label: '2 Days', description: '48 hours' },
    { hours: 72, label: '3 Days', description: '72 hours' },
    { hours: 96, label: '4 Days', description: '96 hours' },
    { hours: 120, label: '5 Days', description: '120 hours' },
    { hours: 480, label: '20 Days', description: '480 hours' },
    { hours: 1440, label: '60 Days', description: '1440 hours' },
  ];

  return (
    <div className="grid grid-cols-2 gap-2">
      {options.map((option) => (
        <button
          key={option.hours}
          className={`
            p-2 rounded-lg border text-left transition-all duration-200
            ${
              selected === option.hours
                ? 'border-pink-300 bg-pink-50 dark:border-pink-500 dark:bg-pink-900/20'
                : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600'
            }
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-sm'}
          `}
          onClick={() => !disabled && onChange(option.hours)}
          disabled={disabled}
        >
          <div className="text-sm font-medium text-gray-900 dark:text-gray-100">{option.label}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400">{option.description}</div>
        </button>
      ))}
    </div>
  );
}
